// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';
import XHR from 'components/lib/swell-ui-0.0.3/utils/XHR';
import SchoolsUtil from 'utils/SchoolsUtil';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper';
import NoResultsMessage from 'components/shared/NoResultsMessage';

// page-specific/etc.
import SchoolList from 'components/schools/SchoolList';

class SchoolsOverviewPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // XHR stuff
      queue: {},
      fetching: false,
      error: '',

      // filters
      filters: {
        relationships: ['parent', 'child'], // whether we should show schools that are parents, children, or both
        schooltypes: [],

        schoolyears: [],

        locations: [],

        projects: [],
        productGroups: [],
        products: [],

        operators: ['AND', 'AND']
      },
      showFiltersRestoreNotice: false,
      searchKey: '',

      // this is the object(s) before any filtering/search
      fetchedData: {
        schools: []
      },

      // current object(s)
      currData: {
        schools: [],

        sortBy: 'id',
        sortDir: 'ASC',

        offset: 0,
        limit: 500
      }

      // etc.
    };

    this.abortXHRQueue = this.abortXHRQueue.bind(this);

    this.handleFilters = this.handleFilters.bind(this);
    this.handleSearchUpdate = this.handleSearchUpdate.bind(this);
    this.fetchSchools = this.fetchSchools.bind(this);
    this.refreshSchools = this.refreshSchools.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);

    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.sort = this.sort.bind(this);

    this.downloadCSV = this.downloadCSV.bind(this);

    this.handleRecipientListUpdate = this.handleRecipientListUpdate.bind(this);
    this.handleSelectAllRecipients = this.handleSelectAllRecipients.bind(this);
  }

  componentWillMount() {
    const currFiltersJSON = window.localStorage.getItem('colibri:schools-overview:filters:v2.2');
    if (currFiltersJSON) {
      const currFilters = JSON.parse(currFiltersJSON);

      this.setState({
        filters: currFilters,
        showFiltersRestoreNotice: true
      }, () => {
        window.setTimeout(() => {
          this.setState({
            showFiltersRestoreNotice: false
          });
        }, 2000);

        this.fetchSchools();
      });
    } else {
      this.fetchSchools();
    }
  }

  componentWillUnmount() {
    this.abortXHRQueue();
  }

  abortXHRQueue() {
    // abort all Ajax calls
    Object.keys(this.state.queue).forEach((key) => {
      const controller = this.state.queue[key];
      if (controller) {
        XHR.abort(controller);
      }
    });
  }

  fetchSchools() {
    this.setState({
      error: ''
    }, () => {
      if (!this.props.appData.cache.schools) {
        alert('no schools!');
      }

      this.setState((prevState) => {
        prevState.fetchedData.schools = this.props.appData.cache.schools;

        return prevState;
      }, () => {
        this.refreshSchools();
      });
    });
  }

  handleFilters(data) {
    this.setState({
      filters: data
    }, () => {
      // save for later
      const currFiltersJSON = JSON.stringify(data);
      window.localStorage.setItem('colibri:schools-overview:filters:v2.2', currFiltersJSON);

      this.refreshSchools();
    });
  }

  handleSearchUpdate(searchKey, e) {
    this.setState((prevState) => {
      prevState.searchKey = searchKey;

      return prevState;
    }, () => {
      this.refreshSchools();
    });
  }

  handleSortingChange(sortBy, sortDir) {
    this.setState((prevState) => {
      prevState.currData.sortBy = sortBy;
      prevState.currData.sortDir = sortDir;

      return prevState;
    }, () => {
      this.refreshSchools();
    });
  }

  sort(items) {
    if (!this.state.currData.sortBy || !this.state.currData.sortDir) {
      alert('do NOT know how to sort :-/');

      return items;
    }

    items.sort((itemA, itemB) => {
      let a = '';
      let b = '';
      let prop = '';

      switch (this.state.currData.sortBy) {
        case 'id':
          a = itemA.id;
          b = itemB.id;
          break;
        case 'school_name':
        case 'school_city_name':
        case 'school_province_name':
        case 'school_region_name':
          prop = this.state.currData.sortBy.replace('school_', '');
          a = itemA[prop];
          b = itemB[prop];
          break;
        // case 'orders_num_kits':
        //   a = itemA.kits ? itemA.kits.length : 0;
        //   b = itemB.kits ? itemB.kits.length : 0;
        //   break;
        // case 'orders_num_teachers':
        //   a = itemA.teachers ? itemA.teachers.length : 0;
        //   b = itemB.teachers ? itemB.teachers.length : 0;
        //   break;
        // case 'mailings_num_accepted':
        // case 'mailings_num_delivered':
        // case 'mailings_num_opened':
        // case 'mailings_num_clicked':
        // case 'mailings_num_complained':
        // case 'mailings_num_failed':
        //   prop = this.state.currData.sortBy.replace('mailings_', '');
        //   a = itemA.mailings ? itemA.mailings[prop] : 0;
        //   b = itemB.mailings ? itemB.mailings[prop] : 0;
        //   break;
        // unknown prop
        default:
          alert('Wrong sorting prop, will die');

          return false;
      }

      // normalize
      if (window.parseFloat(a) == a && window.parseFloat(b) == b) {
        // value is float-like, cast to that
        a = window.parseFloat(a);
        b = window.parseFloat(b);
      } else if (window.parseInt(a) == a && window.parseInt(b) == b) {
        // value is int-like, cast to that
        a = window.parseInt(a);
        b = window.parseInt(b);
      } else {
        // it's a string value, clean it up
        a = a ? String(a) : '';
        b = b ? String(b) : '';
        a = a.trim();
        b = b.trim();
        a = a.toLowerCase();
        b = b.toLowerCase();
      }

      if (a < b){
        return -1;
      }
      if (a > b){
        return 1;
      }

      return 0;
    });

    if (this.state.currData.sortDir == 'DESC') {
      items = items.reverse();
    }

    return items;
  }

  refreshSchools() {
    // filter schools
    let schoolsFiltered = [];

    this.state.fetchedData.schools.forEach((school) => {
      // filter by relationship (plesso/I.C.)
      let relationshipsOK = false;

      if (this.state.filters.relationships.indexOf('parent') != -1 && !school.parent_school_id) {
        relationshipsOK = true;
      }
      if (this.state.filters.relationships.indexOf('child') != -1 && school.parent_school_id) {
        relationshipsOK = true;
      }

      // filter by school types
      let schooltypesOK = false;

      if (school.type) {
        if (this.state.filters.schooltypes && this.state.filters.schooltypes.length) {
          for (let i=0; i<this.state.filters.schooltypes.length; i++) {
            let schooltype = this.state.filters.schooltypes[i];

            const typeGroups = SchoolsUtil.getSchoolclassGroupsFromType(school.type);
            if (typeGroups.indexOf(schooltype) != -1) {
              schooltypesOK = true;

              break;
            }
          }
        } else {
          schooltypesOK = true;
        }
      } else {
        console.error('NO school type!');
      }

      // filter by schoolyears
      let schoolyearsOK = false;
      if (this.state.filters.schoolyears.length) {
        for (let i=0; i<this.state.filters.schoolyears.length; i++) {
          const filterSchoolyear = this.state.filters.schoolyears[i];
          const schoolSchoolyears = school.order_schoolyears || [];

          schoolyearsOK = schoolSchoolyears.indexOf(filterSchoolyear) !== -1;
        }
      } else {
        schoolyearsOK = true;
      }

      // filter by locations
      let locationsOK = false;
      if (this.state.filters.locations.length) {
        for (let i=0; i<this.state.filters.locations.length; i++) {
          let location = this.state.filters.locations[i];

          if (school.region_id == location || school.province_id == location || school.city_id == location) {
            locationsOK = true;

            break;
          }

        }
      } else {
        locationsOK = true;
      }

      // filter by products
      let productsOK = false;

      const products = Object.assign(this.state.filters.products, {}); // turn product group(s) into products
      if (this.state.filters.productGroups) {
        this.state.filters.productGroups.forEach((groupId) => {
          const groupProducts = this.props.appData.cache.kitsByGroup[groupId];

          groupProducts.forEach((product) => {
            products.push(product.id);
          });
        });
      }
      if (products.length) {
        if (school.order_kit_ids && school.order_kit_ids.length) {
          for (let i=0;i<products.length; i++) {
            const product = products[i];

            if (school.order_kit_ids.indexOf(product) != -1) {
              productsOK = true;

              break;
            }
          }
        }
      } else {
        productsOK = true;
      }

      // filter by search
      let searchOK = false;
      if (this.state.searchKey) {
        const searchKey = this.state.searchKey.toLowerCase();

        ['id', 'name', 'address', 'email', 'certified_email'].forEach((prop) => {
          if (school[prop] && school[prop].toLowerCase().indexOf(searchKey) !== -1) {
            searchOK = true;
          }
        });
      } else {
        searchOK = true;
      }

      if (relationshipsOK && schooltypesOK && locationsOK && schoolyearsOK && productsOK && searchOK) {
        schoolsFiltered.push(school);
      }
    });

    // sort
    const schoolsFilteredSorted = this.sort(schoolsFiltered);

    this.setState((prevState) => {
      prevState.currData.schools = schoolsFilteredSorted;
      prevState.currData.offset = 0;

      return prevState;
    });
  }

  handlePaginationChange(offset) {
    this.setState((prevState) => {
      prevState.currData.offset = offset;

      return prevState;
    });
  }

  downloadCSV() {
    const CSV_FILENAME = 'Scuole-' + this.state.filters.locations.join('.') + '-' + this.state.filters.schoolyears.join('.') + this.state.filters.products.join('.') + '-' + (new Date()).getTime() + '.csv';
    const items = this.state.currData.schools;
    if (!items || !items.length) {
      return;
    }

    let csvItems = items.map((item) => {
      // normalize
      if (item.mailings) {
        Object.keys(item.mailings).forEach((key) => {
          item['mailings_' + key] = item.mailings[key] ? item.mailings[key] : 0;
        });
      }
      if (item.teachers && item.teachers.length) {
        item.teachers = item.teachers.map((teacher) => {
          return teacher.first_name + ' ' + teacher.last_name;
        }).join(', ');
      }
      if (item.kits && item.kits.length) {
        item.kits = item.kits.map((kit) => {
          return '"' + kit.name + '"';
        }).join(', ');
      }

      // clean up
      delete item.mailings;

      return item;
    });

    CSV.export(CSV_FILENAME, csvItems, ';');
  }

  handleRecipientListUpdate(recipients) {
    if (this.props.onRecipientListUpdate != undefined) {
      this.props.onRecipientListUpdate(recipients, 'schools');
    }
  }

  handleSelectAllRecipients() {
    if (window.confirm('Sei sicuro/a di voler selezionare tutti i risultati in tutte le pagine..?') == false) {
      return;
    }

    let recipientsById = {};
    this.state.currData.schools.forEach((school) => {
      recipientsById[school.id] = school;
    });

    this.handleRecipientListUpdate(recipientsById, 'schools');
  }

  render() {
    const fetching = Object.keys(this.state.queue).length;

    let dataLabel = 'Scuole';
    if (this.state.searchKey) {
      dataLabel += ' con "' + this.state.searchKey + '"';
    }

    return (
      <div>
        <PageHeader>
          <MainHeading
            icon="fa fa-school"
            title={fetching == false ? 'Scuole' : <span>Scuole <small><Spinner /></small></span>}
            descr="Panoramica scuole"
          />
        </PageHeader>

        <div className={'container animated ' + (this.state.showFiltersRestoreNotice ? 'fadeInDown' : 'fadeOutUp')}>
          <div className="row">
            <div className="col-12">
            <div className="popover fade bs-popover-top show" style={{position: 'absolute', top: '-55px', left: '15px'}}>
              <div className="arrow" style={{left: '50px'}}></div>
                <div class="popover-body">
                  <i className="fa fa-check text-success" style={{fontSize: '20px', float: 'left', marginRight: '12px', marginTop: '10px'}} /> Filtri ripristinati come da ultima sessione di lavoro
                </div>
              </div>
            </div>
          </div>
        </div>

        <FiltersToolbar
          filters={['parenthood', 'schooltypes', 'locations', 'schoolyears', 'projects']}
          collapsable={true}

          onChange={this.handleFilters}

          data={this.state.filters}
          appData={this.props.appData}
        />

        <SortingToolbar
          options={[
            {
              label: 'id',
              name: 'id'
            },
            {
              label: 'Scuola/ nome',
              name: 'school_name'
            },
            {
              label: 'Scuola/ città',
              name: 'school_city_name'
            },
            {
              label: 'Scuola/ provincia',
              name: 'school_province_name'
            },
            {
              label: 'Scuola/ regione',
              name: 'school_region_name'
            },
            // {
            //   label: 'Ordini/ kit',
            //   name: 'orders_num_kits'
            // },
            // {
            //   label: 'Ordini/ insegnanti',
            //   name: 'orders_num_teachers'
            // }
          ]}
          sortBy={this.state.currData.sortBy}
          sortDir={this.state.currData.sortDir}

          onChange={this.handleSortingChange}
        />

        {
          !this.state.currData.schools.length && !this.state.filters.schoolyears.length && !this.state.filters.locations.length && !this.state.filters.productGroups.length && !this.state.filters.products.length && !this.state.searchKey ? (
            <NoResultsMessage />
          ) : ''
        }
        {
          this.state.error ? (
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="alert alert-danger">
                    <i className="fa fa-exclamation-triangle" /> ERRORE! {this.state.error}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <PageDataWrapper
              appData={this.props.appData}

              data={{
                label: fetching == false ? this.state.currData.schools.length + ' ' + (this.state.currData.schools.length == 1 ? 'scuola' : 'scuole') : <Spinner />, // keep some character in there, so that layout doesn't break
                descr: dataLabel,

                onExport: this.downloadCSV
              }}
              pagination={{
                count: this.state.currData.schools.length,
                offset: this.state.currData.offset,
                limit: this.state.currData.limit,
                onChange: this.handlePaginationChange
              }}
              filters={{
                tabs: []
              }}
              search={{
                placeholder: 'Cerca scuole',
                onChange: this.handleSearchUpdate,
                onSubmit: null
              }}
              status={{
                fetching: fetching,
                errors: null
              }}
            >
              <p>
                <span className="badge badge-info" style={{width: '1.25em', height: '1.25em'}}>&nbsp;</span> <small style={{fontSize: '9px'}}>= DELIVERED</small><br />
                <span className="badge badge-danger" style={{width: '1.25em', height: '1.25em'}}>&nbsp;</span> <small style={{fontSize: '9px'}}>= FAIL</small><br />
                <span className="badge badge-warning" style={{width: '1.25em', height: '1.25em'}}>&nbsp;</span> <small style={{fontSize: '9px'}}>= OPEN</small><br />
                <span className="badge badge-success" style={{width: '1.25em', height: '1.25em'}}>&nbsp;</span> <small style={{fontSize: '9px'}}>= CLICK</small>
              </p>

              {
                Object.keys(this.props.appData.mailings.mailingPanelList.schoolsById).length > 0 ? (
                  <p className="alert alert-info mt-3">
                    <i style={{fontSize: '17px'}} className="fa fa-envelope mr-2" />

                    {Object.keys(this.props.appData.mailings.mailingPanelList.schoolsById).length} risultati su {this.state.currData.schools.length} selezionati per mailing

                    {
                      Object.keys(this.props.appData.mailings.mailingPanelList.schoolsById).length != this.state.currData.schools.length ? (
                        <button className="btn btn-primary ml-2" onClick={this.handleSelectAllRecipients}>Seleziona tutti</button>
                      ) : ''
                    }
                  </p>
                ) : ''
              }

              {
                <SchoolList
                  schools={this.state.currData.schools.slice(this.state.currData.offset).slice(0, this.state.currData.limit)}

                  recipientList={this.props.appData.mailings.mailingPanelList.schoolsById}
                  onRecipientListUpdate={this.handleRecipientListUpdate}
                />
              }
            </PageDataWrapper>
          )
        }
      </div>
    );
  }
}

export default SchoolsOverviewPage;


// WEBPACK FOOTER //
// ./src/pages/schools/SchoolsOverviewPage.js